export default "__VITE_ASSET__DHJUJRUA__"